var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "z-index": "999999 !important",
        "background-color": "#ffffff",
      },
    },
    [
      _vm.tipDialog01
        ? _c("div", { staticClass: "sysInfo" }, [
            _c("div", { staticClass: "header" }, [
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.sysMessage")))]),
                _vm._m(0),
              ]),
              _c("div", [
                _c("i", {
                  staticClass: "iconfont icon-a-zu389",
                  staticStyle: { "font-size": "14px" },
                  on: { click: _vm.closeMessage },
                }),
              ]),
            ]),
            _c("div", { staticClass: "infoContant" }, [
              _vm.messageObj.msgType === 4
                ? _c(
                    "div",
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.msgDataContent) },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.getImgSrc($event)
                          },
                        },
                      }),
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.toRecyclingManagement },
                        },
                        [_vm._v(_vm._s(_vm.$t("home.lijiReturn")) + " ")]
                      ),
                    ],
                    1
                  )
                : _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.msgDataContent) },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.getImgSrc($event)
                      },
                    },
                  }),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "margin-right": "10px",
                },
              },
              [
                _vm.messageObj.isRead === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { plain: "", size: "mini" },
                        on: { click: _vm.notTip },
                      },
                      [_vm._v(_vm._s(_vm.$t("GlobalSetObj.notTip")) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.closeMessage },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("GlobalSetObj.close")) +
                        " " +
                        _vm._s(_vm.countdown) +
                        "s "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            title: _vm.$t("GlobalSetObj.tips"),
            visible: _vm.tipDialog02,
            top: "8vh",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipDialog02 = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", [
                    _c("span", { staticStyle: { "margin-right": "10px" } }, [
                      _c("i", {
                        staticClass: "iconfont icon-a-lujing642",
                        staticStyle: { "font-size": "18px" },
                      }),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.messageObj.title))]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            {
              staticClass: "infoContant",
              staticStyle: { height: "500px", "overflow-y": "auto" },
            },
            [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.msgDataContent) },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.getImgSrc($event)
                  },
                },
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "flx-center" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.isDisable,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.notTip },
                },
                [
                  _vm._v(_vm._s(_vm.$t("GlobalSetObj.close")) + " "),
                  _vm.compulsionCountdown
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.compulsionCountdown) + "s"),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.tipDialog03,
            title: "轨迹停更预警",
            top: "8vh",
            width: "650px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipDialog03 = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { "font-size": "25px", color: "red" },
                }),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "8px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _vm._v(
                        " 以下客户包裹轨迹停更时长即将超期，请尽快核实轨迹信息! "
                      ),
                    ]
                  ),
                  _c("div", [
                    _vm._v("轨迹停更超过客户规定时间将面临罚款，请尽快处理!"),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "el-table",
            {
              ref: "tableRef",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
                height: "420",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "客户",
                  "min-width": "150",
                  prop: "scanNumber",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "包裹数量",
                  "min-width": "100",
                  prop: "customerNumber",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户",
                  "min-width": "100",
                  prop: "customerName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "包裹数量",
                  "min-width": "90",
                  prop: "collectStatusName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flx-center", staticStyle: { margin: "10px 0" } },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.notTip } },
                [_vm._v(_vm._s("我已知晓"))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.notTip },
                },
                [_vm._v(_vm._s("立即处理"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showViewer
        ? _c("ElImageViewer", {
            attrs: { "on-close": _vm.closeViewer, "url-list": _vm.imgArr },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { "margin-left": "10px" } }, [
      _c("i", {
        staticClass: "iconfont icon-a-lujing642",
        staticStyle: { "font-size": "18px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }